const pt = {
  login: {
    title: "Sistema de envio de dados",
    email: "E-mail",
    password: "Senha",
    forgotPassword: "Esqueceu a senha",
    logout: "Sair",
    inEmail: "E-mail inválido",
    loginfailed: "Falha no login, e-mail ou senha incorretos",
    enterEmail: "Digite o seu e-mail",
    enterPassword: "Digite a sua senha",
    enterCode: "Digite o código de verificação",
    passwordNotMatch: "As senhas não coincidem",
  },
  forgot: {
    forgotPassword: "Esqueceu a senha",
    tip: "Enviaremos um código de verificação para o seu e-mail",
    email: "E-mail",
    code: "Código de verificação",
    password: "Senha",
    confirmPassword: "Confirmar senha",
    send: "Enviar",
    submit: "Enviar",
    login: "Login",
  },
  menu: {
    mange: "Gerenciar formulários",
    mangeTip: "Criação de formulários de envio de dados, visualização de dados",
    submission: "Preencher formulário",
    account: "Gerenciar conta",
    uwell: "Conta interna",
    external: "Conta externa",
  },
  editList: {
    fill: "Preencher",
    record: "Dados",
    createdTime: "Data de criação",
    formTitle: "Título do formulário",
    titleTip: "Digite um título",
    showInput:
      "Mostrar formulários para preencher e registros de preenchimento",
  },
  editFill: {
    save:"Salvar",
    nosave:'Não salvar',
    backSaveTip:'Você deseja salvar o conteúdo preenchido?',
    submitted:'enviado',
    notsubmitted:'não enviado',

    submit: "Enviar",
    submitSuccess: "Envio realizado com sucesso",
    fillAgain: "Preencher novamente",
    invalid: "Parâmetro inválido",
    noTime: "O formulário não está disponível no momento",
    failedStop: "Falha no envio, o formulário não aceita mais dados",
    failedNot: "Falha no envio, o formulário não existe",
    failedPassed: "Falha no envio, o formulário só pode ser preenchido uma vez",
    failedOnce:
      "Falha no envio, o formulário só pode ser preenchido uma vez por dia",
    noempty: "Os campos obrigatórios não podem estar vazios",
  },
  editInfo: {
    SubmitTime: "Data de envio",
    submitter:'Remetente',
    search: "Buscar",
    clear: "Limpar",
    filter: "Filtrar",
    fieldSetting: "Gerenciar campos",
    export: "Exportar",
    createBy: "Criado por",
    updateTime: "Data de atualização",
    status:'estado',
    action: "Ação",
    detail: "Detalhes",
    edit: "Editar",
    more:"Mais",
    copy:"Cópia de",
    startDate: "Data de início",
    endDate: "Data de término",
    selectAll: "Selecionar tudo",
    confirm: "Confirmar",
    cancel: "Cancelar",
    addFilter: "Adicionar critério de filtragem",
    pleaseSelect: "Por favor, selecione",
    pleaseFillIn: "Por favor, preencha",
    delete: "Excluir",
    filterIncom:
      "O critério de filtragem da linha {num} está incompleto, por favor, verifique",
    noData: "Não há dados disponíveis",
    uploadfailed: "Falha no upload",
    total: "Total: {num} itens",

    deleteTip: 'Esta operação irá excluir os dados. Deseja continuar?',
    deleteSuccess: 'Exclusão bem-sucedida'
  },
  fillIn: {
    equal: "Igual a",
    noequal: "Diferente de",
    contains: "Contém",
    notcontains: "Não contém",
    empty: "Vazio",
    notempty: "Não vazio",
    before: "Antes de",
    after: "Depois de",
    greaterequal: "Maior ou igual a",
    lessequal: "Menor ou igual a",
    greaterthan: "Maior que",
    lessthan: "Menor que",
  },
  editEye: {
    detail: "Dados do formulário",
  },
  editUpdate: {
    editForm: "Editar formulário",
    returnList: "Voltar para a lista",
  },
};

export default pt;
